// utils/imageCompressor.js
export const compressImage = async (file, options = {}) => {
    const { 
      maxWidth = 800, 
      maxHeight = 800, 
      quality = 0.7,
      mimeType = 'image/jpeg' 
    } = options;
  
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
  
          // Calculate new dimensions while maintaining aspect ratio
          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width = Math.floor(width * ratio);
            height = Math.floor(height * ratio);
          }
  
          // Draw image on canvas with new dimensions
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
  
          // Convert to blob with specified quality
          canvas.toBlob(
            (blob) => resolve(blob),
            mimeType,
            quality
          );
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  };